import React from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useMutationAddCustomer, useMutationUpdateCustomer } from 'Customers/hooks/useCustomers';
import useResolveHandler from 'Shared/useResolveHandler';

import {
  initializeValues,
  isInsert,
  shouldLoadFromAPI,
  wizardSteps,
  editWizardSteps,
  getCustomerData,
  wizardWithoutAccountSteps,
} from '../../utility';
import WizardModal from '../WizardModal/WizardModal';

const AddCustomerModal = ({ isOpen, data, onClose, createAccount }) => {
  const queryClient = useQueryClient();
  const wizardIsInsert = isInsert(data);
  const wizardShouldFetch = shouldLoadFromAPI(data);
  const wizardInitValues = initializeValues(wizardIsInsert, wizardShouldFetch ? {} : data);
  const { isLoading: loadingAdd, mutate: addCustomerMutate } = useMutationAddCustomer();
  const { isLoading: lodaingUpdate, mutate: updateCustomerMutate } = useMutationUpdateCustomer();
  const { responseStatus, setStatus } = useResolveHandler();

  const onSubmit = (submitData, formikHelpers) => {
    const newCustomer = getCustomerData(submitData, wizardIsInsert, createAccount);
    const mutateProcess = wizardIsInsert ? addCustomerMutate : updateCustomerMutate;
    mutateProcess(wizardIsInsert ? newCustomer : { id: data.id, data: newCustomer }, {
      onSuccess: async () => {
        if (wizardIsInsert) formikHelpers.resetForm();
        setStatus(true, onClose);
        await queryClient.refetchQueries(['customers', 'getCustomerById']);
      },
    });
  };
  return (
    <WizardModal
      onClose={onClose}
      isOpen={isOpen}
      initialValues={wizardInitValues}
      onSubmit={onSubmit}
      title={wizardIsInsert ? 'New Customer' : 'Edit Customer'}
      isLoading={loadingAdd || lodaingUpdate}
      generateWizardStepsWithValidation={
        wizardIsInsert ? (createAccount ? wizardSteps : wizardWithoutAccountSteps) : editWizardSteps
      }
      responseStatus={responseStatus}
      submitButtonText={wizardIsInsert ? 'Add' : 'Save'}
      updateKey='accountType'
    />
  );
};

export default AddCustomerModal;
